<script>
    import { globalSizes } from './store';
    import * as animateScroll from 'svelte-scrollto';
    
    import { quadInOut } from 'svelte/easing';
    import { fly, fade } from 'svelte/transition';

    const NAV_ITEMS = [
        {
            name: 'Back to Top ',
            element: 'top'
        },
        {
            name: 'Where to find me',
            element: '#section-find'

        },
        {
            name: 'My Studies',
            element: '#section-studies'
        },
        {
            name: 'About this project',
            element: '#section-about'
        }
    ]

    let scrollY;
    let wSize;
    let menuOpen;

    animateScroll.setGlobalOptions({
        easing: quadInOut,
        duration: 800
    })

    function toggleMenu(e) {
        menuOpen = !menuOpen;
    }

    function customScroll(element) {
        if(wSize < 768) {
            toggleMenu();
        }

        if( element === 'top' ){
            animateScroll.scrollToTop()
        }else {
            animateScroll.scrollTo({ element: element, offset: -$globalSizes.navbarH })
        }

        return;
    }
</script>

<svelte:window bind:scrollY={scrollY} bind:innerWidth={wSize} />

<div class="row {scrollY >= $globalSizes.heroH ? 'fixed' : ''}">
    <nav class="container" bind:clientHeight={$globalSizes.navbarH}>
        { #if wSize < 768 }
            <i transition:fade on:click="{() => toggleMenu() }" class="fas fa-bars menu-trigger"></i>
        { /if }
        <ul class="{ menuOpen ? 'menu-open' : '' }">
            { #each NAV_ITEMS as item, i }
                { #if wSize >= 768 || menuOpen }
                <li 
                    on:click={() => customScroll(item.element)}
                    transition:fly={{ y: -50, duration: 300, delay: 100 * i }}
                >
                    {item.name}
                </li>
                { /if }
            { /each }
        </ul>
    </nav>
</div>

<style lang="less">
    .row {
        background: var(--color-gray-400);
        box-shadow: 0 2px 10px 0px rgba(0,0,0,.0);
        transition: box-shadow .3s ease-out;

        .container{
            min-height: 40px;
        }
        &.fixed{
            position: fixed;
            top: 0;
            z-index: 10;
            box-shadow: 0 2px 10px 0px rgba(0,0,0,.2);
        }
        nav {
            font-family: var(--font-alt);
            font-size: 18px;
            position: relative;

            .menu-trigger {
                position: absolute;
                top: 0;
                left: 50%;
                margin: 0 0 0 -20px;
                width: 40px;
                line-height: 40px;
                text-align: center;
            }
            ul {
                display: flex;
                padding: 15px 0;

                li {
                    float: left;
                    margin: 0 20px;
                    color: var(--color-gray-200);
                    cursor: pointer;
                    transition: color .3s ease-out;

                    @media screen and (min-width: 1024px) {
                        &:hover {
                            color: var(--color-primary);
                        }
                    }

                    &:first-child {
                        margin-left: 0;
                    }
                }

                @media screen and (max-width: 767px) {
                    padding: 40px 0 0 0;
                    flex-flow: row wrap;
                    
                    li {
                        flex: 1 1 100%;
                    }
                }

            }

            @media screen and (max-width: 1024px) and (min-width:768px) {
                ul {
                    justify-content: center;
                }
            }

            @media screen and (max-width: 767px) {
                ul {
                    justify-content: center;

                    li {
                        padding: 10px 30px;
                        margin: 0;

                        &:last-child {
                            padding-bottom: 30px;
                        }
                    }
                }
            }
        }
    }
</style>